import React, { useEffect, useState } from 'react';
import './headboardUnete.scss';
import { ReferenciaCabecera } from '../../../interfaces/ReferenciaCabecera';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from "@contentful/rich-text-types";
import { normalizeTwoWords, findTarget, findRel, OptimizeImage } from "../../../shared/utils/stringUtilities";
import ModalSolicitudServicios from "../../molecules/modal-solicitud-servicios/modalSolicitudServicios";
import useElementSize from '../../../hooks/useElementSize';

interface IHeadboardUnete extends ReferenciaCabecera {
    callToAction: () => void;
}
const HeadboardUnete = (props: IHeadboardUnete) => {

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

     const headerSize = useElementSize(".m-header");

    const renderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
        },
        renderText: text => {
            return text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []);
        },
    };

    //Bloque creado para el formulario de solicitud de servicios//
    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname : ''
    
    const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

    useEffect(() => {
        if (localStorage.getItem('solicitarServicios') == null 
            && pathName.split('/')[3] === 'solicitud-servicios'){
            setIsOpenModal(true)
        }
        setTimeout(() => {
            localStorage.removeItem('solicitarServicios')
        }, 3000)
    },[])
    //Bloque creado para el formulario de solicitud de servicios//

    return (
        <div className="o-headboard-unete" style={{ marginTop: `${headerSize.height}px` }}>
            <div className="o-headboard-unete__container">
                <div className="o-headboard-unete__container__content">
                    {/* Titulo principal */}
                    {props.tituloPrincipal && (
                        <h1 className="o-headboard-unete__container__content__title">
                            {props.tituloPrincipal}
                        </h1>
                    )}
                    {/* Se renderiza la imagen para mobile */}
                    {props.imagenHeader ? (
                        <div className={`o-headboard-unete__container__cover hide-desktop ${props.contentful_id === "4PLtkDl7RTs252iSrTTe9A" ? "hide-mobile" : ""}`}>
                            {props.imagenHeader && (
                                <img
                                    className="o-headboard-unete__container__cover__img"
                                    src={OptimizeImage(
                                        props.imagenHeader.file.url,
                                        props.imagenHeader.file.contentType,
                                        550
                                    )}
                                    alt={
                                        (props.imagenHeader &&
                                            props.imagenHeader.title) ||
                                        "imagen cabecera"
                                    }
                                    loading="lazy"
                                />
                            )}
                        </div>
                    ) : null}
                    {/* texto descripcion */}
                    {props.descripcion && (
                        <article className="o-headboard-unete__container__content__text">
                            {props.descripcion.json.content && documentToReactComponents(props.descripcion.json, renderOptions)}
                        </article>
                    )}
                    {props.referenciaTags && (
                        <div className="o-headboard-unete__container__content__tags">
                            {props.referenciaTags.map((value, index) => (
                                <a
                                    key={index}
                                    className={`o-headboard-unete__container__content__tags__tag gtm${normalizeTwoWords(
                                        props.tituloPrincipal
                                    )}Tag${normalizeTwoWords(value.nombreTag)}`}
                                    title={value.nombreTag}
                                    onClick={props.callToAction}
                                >
                                    {value.nombreTag}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
                {/* Se renderiza imagen para desktop */}
                {props.imagenHeader ? (
                    <div className="o-headboard-unete__container__cover hide-mobile">
                        {props.imagenHeader && (
                            <img
                                className="o-headboard-unete__container__cover__img"
                                src={OptimizeImage(
                                    props.imagenHeader.file.url,
                                    props.imagenHeader.file.contentType,
                                    550
                                )}
                                alt={
                                    (props.imagenHeader &&
                                        props.imagenHeader.title) ||
                                    "imagen cabecera"
                                }
                                loading="lazy"
                            />
                        )}
                    </div>
                ) : null}
                {isOpenModal && (
                    <ModalSolicitudServicios showModal={isOpenModal} onClose={closeModal}/>
                )}
            </div>
        </div>
    );
}

export default HeadboardUnete;
